import React from "react"
import clsx from "clsx"
import SurveyFormBuilderErrors from "../SurveyFormBuilderErrors"

class SurveyFormBuilderGeneral extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      setOnce: false,
      body: this.props.email ? this.props.email.body : '',
      status: this.props.email ? this.props.email.status : true,
      email_type: this.props.email && this.props.email.email_type ? this.props.email.email_type : "event",
      testEmailSending: false,
      updated_at: this.props.email ? this.props.email.updated_at : '',
    }
    this.sendTestEmail = this.sendTestEmail.bind(this)
  
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">
        {this.renderErrors()}
        {this.renderGeneralForm()}
      </div>
    )
  }

  renderErrors() {
    var errors = SurveyFormBuilderErrors.generalErrors(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map( (error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }


  renderFieldClasses(field) {
    var classname = 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  renderGeneralForm() {
    return (
      <div>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('title')}*`}</label>
              <input
                id="name" 
                type="text" 
                name="title" 
                className={this.renderFieldClasses('title')}
                value={this.props.title || ''} 
                onChange={this.props.onChangeTextField} />
              {this.renderFieldErrors("title")}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('description')}</label>
              <textarea
                id="name" 
                type="text" 
                name="description" 
                rows={7}
                className="form-control"
                value={this.props.description || ''} 
                onChange={this.props.onChangeTextField} 
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group" style={{marginBottom: 0, position: 'relative'}}>
              <label>{"Send Test Survey Email"}</label>
              <div className="input-group send-test-email-group">
                <input ref="test_email_addresses" type="text" className="form-control" placeholder={I18n.t('email_addresses_comma_separated')} />
                <span className="input-group-btn">
                  <button className="btn no-ladda btn-dark" ref="send_test_email_button" type="submit" style={{height: 34}} onClick={this.sendTestEmail}>{I18n.t('send')}</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  sendTestEmail(event) {
    var self = this;

    event.preventDefault();
    event.stopPropagation();

    self.setState({testEmailSending: true});

    $.ajax({
      type: 'POST',
      url: this.props.sendTestEmailPath,
      data: {
        email: $.extend({}, this.props.email, {from_address: this.state.from_address, to_addresses: $(this.refs.test_email_addresses).val(), body: this.props.tempBody, subject: this.props.tempSubject}),
        survey_form_id: this.props.id

      
      }
    }).done((data) => {
      self.setState({testEmailSending: false});

      if (data.error) {
        $(self.refs.test_email_addresses).tooltip({template: '<div class="tooltip tooltip-error" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>', trigger: 'manual', title: data.error}).tooltip('show');
      } else {
        $(self.refs.test_email_addresses).tooltip({trigger: 'manual', title: data.success}).tooltip('show');
      }

      setTimeout(() => {
        $(self.refs.test_email_addresses).tooltip('destroy').removeAttr('title');
      }, 4000);
    }).fail((data) => {
      self.setState({testEmailSending: false});

      setTimeout(() => {
        $(self.refs.test_email_addresses).tooltip('destroy').removeAttr('title');
      }, 4000);
    });
  }
  
}

export default SurveyFormBuilderGeneral